import { render, staticRenderFns } from "./SemesterSetting.vue?vue&type=template&id=dc006238&scoped=true"
import script from "./SemesterSetting.vue?vue&type=script&lang=js"
export * from "./SemesterSetting.vue?vue&type=script&lang=js"
import style0 from "./SemesterSetting.vue?vue&type=style&index=0&id=dc006238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc006238",
  null
  
)

export default component.exports